// Curated Madeira packages — used for the listing and detail pages.
// Filters: Hiking | Couple | Family | Cultural.

export const packages = [
  // HIKING
  {
    id: 'levada-25-fontes',
    category: 'Hiking',
    title: 'Levada Walk — 25 Fontes',
    shortDescription: 'One of Madeira\'s most beautiful levada walks, leading to the stunning 25 Fontes waterfall through lush laurel forest.',
    longDescription: `Set off from Rabaçal (1,064 m) and descend into a glacial amphitheatre where 25 separate springs feed a single emerald pool. The trail is wide, well-maintained and threads through UNESCO Laurissilva forest with wild lily, heather and old laurel trees twisted by Atlantic winds.

We start before the day-tripper crowds, so you get the waterfall almost to yourself. A swim in the icy pool is optional — recommended in summer, brave in winter.`,
    duration: '6–7 hours',
    difficulty: 'Moderate',
    groupSize: '2-12',
    price: 65,
    image: 'https://images.unsplash.com/photo-1551632811-561732d1e306?w=1200&h=800&fit=crop',
    gallery: [
      'https://images.unsplash.com/photo-1551632811-561732d1e306?w=1200&h=800&fit=crop',
      'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1200&h=800&fit=crop'
    ],
    highlights: [
      'UNESCO Laurissilva forest',
      'Swim under the 25 Fontes waterfall',
      'Local guide with deep area knowledge',
      'Small groups, no rush, no crowds',
      'Pickup and drop-off from your hotel'
    ],
    includes: ['Transport from Funchal area', 'English/Portuguese/French-speaking guide', 'Safety briefing', 'Snack break'],
    notIncludes: ['Lunch', 'Personal hiking gear']
  },
  {
    id: 'pico-ruivo-sunrise',
    category: 'Hiking',
    title: 'Pico Ruivo Sunrise Trail',
    shortDescription: 'Watch the sun rise over the Atlantic from Madeira\'s highest peak — 1,862 m above the clouds.',
    longDescription: `A pre-dawn drive up to Achada do Teixeira, head torches on, and a 2.8 km walk to the summit refuge. We time it so you arrive 15 minutes before sunrise, with hot tea and a small breakfast waiting at the top.

On a clear morning you can see Porto Santo, the Desertas Islands and a sea of clouds covering everything below 1,200 m. It is, quite simply, the most unforgettable hour you can spend on the island.`,
    duration: '5–6 hours (4 a.m. start)',
    difficulty: 'Moderate',
    groupSize: '2-8',
    price: 85,
    image: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1200&h=800&fit=crop',
    gallery: ['https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1200&h=800&fit=crop'],
    highlights: ['Madeira\'s highest peak (1,862 m)', 'Above-the-clouds sunrise', 'Hot tea & breakfast at the summit', 'Photography assistance'],
    includes: ['Hotel pickup before dawn', 'Guide & safety briefing', 'Head torch loan', 'Breakfast & hot drinks at summit'],
    notIncludes: ['Personal hiking gear']
  },
  {
    id: 'caldeirao-verde',
    category: 'Hiking',
    title: 'Caldeirão Verde — The Green Cauldron',
    shortDescription: 'A levada walk through four tunnels culminating in a 100m waterfall plunging into a hidden green amphitheatre.',
    longDescription: `Starting from Queimadas Forest Park in Santana, the PR 9 follows a narrow levada carved into a cliff face. Four short tunnels (head torch required) take you deeper into the Ribeira do Caldeirão Verde valley.

After 6.5 km you reach the climax — a massive natural amphitheatre with a 100m waterfall thundering into a moss-covered pool. The light here, especially in early morning, is otherworldly.`,
    duration: '5–6 hours',
    difficulty: 'Easy–Moderate',
    groupSize: '2-12',
    price: 55,
    image: 'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=1200&h=800&fit=crop',
    gallery: ['https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=1200&h=800&fit=crop'],
    highlights: ['Four tunnels — bring a torch', '100m waterfall at the end', 'Queimadas traditional thatched houses', 'Mossy ancient laurel forest'],
    includes: ['Transport', 'Guide', 'Head torch loan'],
    notIncludes: ['Lunch']
  },

  // COUPLE
  {
    id: 'romantic-sunset-picnic',
    category: 'Couple',
    title: 'Romantic Sunset Picnic at Cabo Girão',
    shortDescription: 'A private picnic on Europe\'s second-highest sea cliff, gourmet basket and Madeira wine pairing.',
    longDescription: `We pick you up in the late afternoon and drive you to a private viewpoint near Cabo Girão — at 580m, one of the highest sea cliffs in Europe.

A blanket on the grass, a wooden hamper of local cheeses, presunto, fresh bread, fruit, and a bottle of Madeira wine. Just the two of you, the Atlantic horizon, and the sun dropping into the ocean.`,
    duration: '3 hours',
    difficulty: 'Easy',
    groupSize: '2',
    price: 140,
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&h=800&fit=crop',
    gallery: ['https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&h=800&fit=crop'],
    highlights: ['Private cliff-top location', 'Gourmet local hamper', 'Madeira wine pairing', 'Sunset over the Atlantic', 'Photography by your guide (optional)'],
    includes: ['Round-trip transport', 'Hamper & blanket', 'Bottle of Madeira wine', 'Local cheese & charcuterie selection'],
    notIncludes: ['Hotel transfers outside Funchal area']
  },
  {
    id: 'couples-spa-nature',
    category: 'Couple',
    title: 'Couples Spa & Nature Retreat',
    shortDescription: 'A slow day combining natural hot pools, mountain bathing, and a couples massage in the laurissilva forest.',
    longDescription: `A reset day for two. Morning starts in the wild north — a private session at a thermal spring near São Vicente, surrounded by ferns and waterfalls.

Lunch is served at a quinta deep in the laurissilva, followed by a 60-minute couples massage using local Madeira honey and Aloe Vera. We finish at sunset overlooking the north coast.`,
    duration: '6 hours',
    difficulty: 'Easy',
    groupSize: '2',
    price: 220,
    image: 'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=1200&h=800&fit=crop',
    gallery: ['https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=1200&h=800&fit=crop'],
    highlights: ['Natural thermal springs', 'Couples massage in the forest', 'Slow lunch at a local quinta', 'Sunset viewpoint stop'],
    includes: ['Pickup & drop-off', 'All entrance fees', 'Lunch & wine', '60-min couples massage'],
    notIncludes: []
  },

  // FAMILY
  {
    id: 'family-adventure-day',
    category: 'Family',
    title: 'Family Adventure Day',
    shortDescription: 'An easy mix of trails, natural rock pools, and a picnic — designed for families with kids 6+.',
    longDescription: `A relaxed, kid-friendly itinerary built around fun and discovery. We start with a short walk on the Vereda dos Balcões (1 hour, flat), then drive to Porto Moniz for an afternoon swimming in the safe lava rock pools.

A casual lunch on the seafront, ice cream stop on the way back. The kids stay engaged, the parents stay relaxed.`,
    duration: '6 hours',
    difficulty: 'Easy',
    groupSize: '4-12',
    price: 55,
    image: 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=1200&h=800&fit=crop',
    gallery: ['https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=1200&h=800&fit=crop'],
    highlights: ['Easy walks suitable for kids 6+', 'Swimming in volcanic rock pools', 'Family-friendly lunch stop', 'Ice cream on the way home'],
    includes: ['Spacious family van', 'Local guide good with kids', 'All entrance fees', 'Picnic snacks'],
    notIncludes: ['Lunch', 'Swimwear & towels']
  },
  {
    id: 'family-coastal-exploration',
    category: 'Family',
    title: 'Coastal Family Exploration',
    shortDescription: 'Rock pools, secret beaches and dolphin spotting along Madeira\'s south coast.',
    longDescription: `A morning of tide pool exploration at Garajau marine reserve, then a short, calm-water boat trip to look for dolphins and turtles. Picnic on a small beach the kids will think they discovered themselves.`,
    duration: '5 hours',
    difficulty: 'Easy',
    groupSize: '4-10',
    price: 60,
    image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=1200&h=800&fit=crop',
    gallery: ['https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=1200&h=800&fit=crop'],
    highlights: ['Marine reserve tide pools', 'Dolphin & turtle spotting (seasonal)', 'Hidden beach picnic', 'Marine biologist guide on board'],
    includes: ['Boat trip', 'Snorkel masks', 'Snacks & drinks', 'Guide'],
    notIncludes: ['Lunch']
  },

  // CULTURAL
  {
    id: 'heritage-tour',
    category: 'Cultural',
    title: 'Madeira Heritage Tour — Funchal to Câmara de Lobos',
    shortDescription: 'A slow walk through the old quarter of Funchal, Mercado dos Lavradores, and lunch in a fisherman\'s village.',
    longDescription: `Start at Praça do Município with the historian-guide, then explore the Sé Cathedral, the painted doors of the Zona Velha, and the Mercado dos Lavradores at its busiest. We try local fruit (Annona, custard apple, white guava) and bolo do caco from a tiny bakery only locals know.

Lunch is at a long table in Câmara de Lobos, the fishing village Churchill painted in 1950. Espetada hung over coals, fresh scabbard fish, and a glass of Madeira wine.`,
    duration: '7 hours',
    difficulty: 'Easy',
    groupSize: '4-12',
    price: 75,
    image: 'https://images.unsplash.com/photo-1571406761758-9a3eed5338ef?w=1200&h=800&fit=crop',
    gallery: ['https://images.unsplash.com/photo-1571406761758-9a3eed5338ef?w=1200&h=800&fit=crop'],
    highlights: ['Funchal old town walking tour', 'Mercado dos Lavradores tasting', 'Câmara de Lobos lunch with locals', 'Madeira wine pairing'],
    includes: ['Walking tour with historian-guide', 'Market tastings', 'Traditional Madeiran lunch', 'Madeira wine'],
    notIncludes: ['Hotel pickup outside Funchal']
  },
  {
    id: 'wine-poncha-tour',
    category: 'Cultural',
    title: 'Wine & Poncha Tasting Tour',
    shortDescription: 'A liquid history of Madeira — Blandy\'s wine lodge, a hidden poncha bar, and a basalt cellar from 1840.',
    longDescription: `Madeira wine survived two world wars and the long sea route to America. In Funchal you taste four styles — Sercial, Verdelho, Bual, Malmsey — including a sip of a 1934 vintage if available.

The afternoon takes you to Câmara de Lobos and Taberna da Poncha, where the mexelote (wooden pestle) still rules. We finish at sunset with a glass of vinho seco in a stone cellar built in 1840.`,
    duration: '5 hours',
    difficulty: 'Easy',
    groupSize: '2-8',
    price: 90,
    image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=1200&h=800&fit=crop',
    gallery: ['https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=1200&h=800&fit=crop'],
    highlights: ['Blandy\'s wine lodge tasting', 'Authentic poncha bar', '1840 stone wine cellar', 'Wine pairing with local cheeses'],
    includes: ['All tastings', 'Guide', 'Transport between stops'],
    notIncludes: ['Bottles to take home']
  }
];

export const PACKAGE_CATEGORIES = ['Hiking', 'Couple', 'Family', 'Cultural'];
